import wretch from 'wretch';
import * as v from 'valibot';
import { TeamsSchema, TTeams } from '@fe-learner-common/api/schemas/teams';
import { localizedErrorHandlers } from '@fe-core/api';

export const getTeams = async (baseUrl: string): Promise<TTeams> => {
  const url = `${baseUrl}/teams`;
  const instance = wretch(url, {
    credentials: 'include',
  }).get();

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(TeamsSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output?.data;
    } else {
      console.error(
        'fe-learner-courses | getTeams | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid getTeams response');
    }
  });
};
